import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProdutoPage from "../pages/produto/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/produto/:slug",
    element: <ProdutoPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
